import React from "react";

import { useIntersect } from "hooks/useIntersect";

import classNames from "classnames";
import * as fromProjects from "store/Projects";

import { ProjectContentBlock } from "./ProjectContentBlock";

interface IProps {
  animationReady: boolean;
  contentSection: fromProjects.IContentSection;
}

const ProjectSectionComponent: React.FC<IProps> = ({
  animationReady,
  contentSection,
  ...props
}) => {
  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const sectionStyles = {
    backgroundColor: contentSection.backgroundColor,
    backgroundImage:
      "url(/assets/images/work/" + contentSection.backgroundImage + ")",
  };
  return (
    <section
      ref={inViewRef}
      className={classNames(
        "projectSectionWrapper",
        [contentSection.backgroundShade + "BackgroundShade"],
        { textLight: contentSection.backgroundShade === "dark" },
        { textDark: contentSection.backgroundShade === "light" },
        [contentSection.topPadding + "TopPadding"],
        [contentSection.bottomPadding + "BottomPadding"]
      )}
      style={sectionStyles}
    >
      {contentSection.contentBlocks.map((contentBlock, index) => (
        <ProjectContentBlock
          key={index}
          contentSection={contentSection}
          contentBlock={contentBlock}
          contentBlockIndex={index}
          animateIn={inView}
        />
      ))}
    </section>
  );
};

export const ProjectSection = ProjectSectionComponent;
